import React, { useEffect } from "react";
import { Content, Main } from "../../../../components/Layout";
import { useParams } from "react-router-dom";
import useWrapper from "../../../../hooks/useWrapper";
import { useOutletContext } from "react-router-dom";
import AttendanceChat from "../../../../components/AttendanceChat";

export default function GroupMessenger() {
  const { commercial } = useOutletContext();
  const { setbreadcrumb } = useWrapper();
  const { attendanceId } = useParams();

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([{ label: "Turmas", url: "/groups" }, { label: commercial.institution.name }]);
    }
  }, [commercial]);

  return (
    <Main>
      <Content>
        <AttendanceChat id={attendanceId} />
      </Content>
    </Main>
  );
}
